module.exports = __webpack_public_path__ + "static/media/branding_01_C.45e44fc2.png";